import { createContext, useCallback, useContext, useMemo } from 'react';
import { Color } from '../nestedDraggable.models';
import type { DroppableHeaderContextType } from './droppableHeaderV2.models';

export const DroppableHeaderContext = createContext<DroppableHeaderContextType | undefined>(undefined);

export function useDroppableHeaderContext() {
  const context = useContext(DroppableHeaderContext);
  if (!context) {
    throw new Error('useDroppableHeaderContext must be used within a DroppableHeaderContext.Provider');
  }

  const { textColor, glyphColor } = useMemo((): Color => {
    switch (context.color) {
      case 'GREEN':
      case 'GREY':
        return {
          textColor: 'color-white',
          glyphColor: '#FFFFFF'
        };
      case 'BLUE':
      default:
        return {
          textColor: 'color-dark',
          glyphColor: '#515253'
        };
    }
  }, [context.color]);

  const handleClickEvent = useCallback((e: React.MouseEvent, onClick: () => void) => {
    e.stopPropagation();
    onClick();
  }, []);

  return { ...context, textColor, glyphColor, handleClickEvent };
}
